import React, { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";
import loadImage from "blueimp-load-image";
import { IMAGE_UPLOAD, VIDEO_UPLOAD, GIF_UPLOAD } from "../../Constants/types";
const FileUpload = ({ onChangeContent }) => {
  const [mediaContent, setContent] = useState(null);
  const [mediaType, setMediaType] = useState("");
  const [fileViewable, setFileViewable] = useState(null);
  const [isVideo, setIsVideo] = useState(false);
  const fileButton = useRef();
  useEffect(() => {
    if (mediaContent && mediaType) {
      onChangeContent({ mediaType, mediaContent });
    }
  }, [mediaContent, mediaType]);
  const selectFile = (e) => {
    console.log("e.target", e.target);
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      console.log("content.type", content.type);
      if (content.type === "image/png" || content.type === "image/jpeg") {
        setMediaType(IMAGE_UPLOAD);
        setIsVideo(false);
        const type = content.type;
        loadImage.parseMetaData(content, function (data) {
          var orientation = 0;
          if (data.exif) {
            orientation = data.exif.get("Orientation");
          }
          loadImage(
            content,
            function (canvas) {
              var base64data = canvas.toDataURL(type);
              var img_src = base64data.replace(
                /^data\:image\/\w+\;base64\,/,
                ""
              );
              let img_content = "data:" + type + ";base64," + img_src;
              setFileViewable(img_content);
              setContent(img_src);
            },
            {
              canvas: true,
              orientation: orientation,
            }
          );
        });
      } else if (content.type === "image/gif") {
        setMediaType(GIF_UPLOAD);
        setIsVideo(false);
        setFileViewable(URL.createObjectURL(content));
        setContent(content);
      } else if (content.type === "video/mp4") {
        setMediaType(VIDEO_UPLOAD);
        setIsVideo(true);
        setFileViewable(URL.createObjectURL(content));
        setContent(content);
      }
    }
  };
  return (
    <React.Fragment>
      <div className="col-12 mb-1">
        <label htmlFor="image">Upload an image, gif or video: &nbsp;</label>
        <input
          ref={fileButton}
          type="file"
          accept="video/mp4,image/gif,image/jpeg,image/png"
          className="form-control-file"
          style={{ display: "none" }}
          onChange={selectFile}
        />
        <button
          className="btn btn-green"
          onClick={() => fileButton.current.click()}
        >
          Choose File
        </button>
      </div>
      <div className="col-12">
        {fileViewable &&
          (isVideo ? (
            <ReactPlayer
              url={fileViewable}
              width="100%"
              height="100%"
              controls={true}
            />
          ) : (
            <div className="mt-3">
              <img
                src={fileViewable}
                alt="post_img"
                className="w-100"
                style={{
                  maxHeight: "100px",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
      </div>
    </React.Fragment>
  );
};
export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/FileUpload.js